module.exports = __webpack_public_path__ + "static/media/9 Registratin Table.1a012f14.jpg";